import { render, staticRenderFns } from "./pay-szf.vue?vue&type=template&id=081d88ef&scoped=true"
import script from "./pay-szf.vue?vue&type=script&lang=js"
export * from "./pay-szf.vue?vue&type=script&lang=js"
import style0 from "./pay-szf.vue?vue&type=style&index=0&id=081d88ef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081d88ef",
  null
  
)

export default component.exports